<template>
  <div class="index">
    <!-- 筛选 -->
    <!-- <section>
      <el-form class="section-filter" :model="filterForm" :inline="true" label-width="100px">
        <div class="filter-col">
          <el-form-item label="企业名称：">
            <el-input clearable v-model="filterForm.u_idCard" placeholder="请输入企业名称"></el-input>
          </el-form-item>
        </div>
        <div class="filter-area">
          <div class="filter-area-label">地区：</div>
          <AreaPicker ref="AreaPicker" @getData="filterHandler" />
        </div>
        <div class="filter-btn">
          <el-button type="primary" @click="filterHandler()" icon="el-icon-search">查询</el-button>
          <el-button type="" @click="resetHandler()" icon="el-icon-refresh-right">重置</el-button>
        </div>
      </el-form>
    </section> -->
    <!-- 用户操作按钮 -->
    <section class="section-btns">
      <!-- <el-button type="" icon="el-icon-view" @click="viewHandler" v-if="btnShow.search" :disabled="selectRows.length!==1">查看</el-button> -->
      <el-button type="primary" icon="el-icon-plus" @click="createHandler" v-if="btnShow.create">创建</el-button>
      <el-button type="primary" icon="el-icon-edit" @click="modifyHandler" v-if="btnShow.modify" :disabled="selectRows.length!==1">编辑</el-button>
      <!-- <el-upload
        :action="importAction"
        accept=".xls,.xlsx" :limit="1" style="margin:0 10px;" :file-list="importFiles"
        :before-upload="beforeImport" :on-success="importSuccess" v-if="btnShow.import">
        <el-button type="success" icon="el-icon-upload2">数据导入</el-button>
      </el-upload>
      <el-button type="success" icon="el-icon-download" @click="downloadHandler">下载模板</el-button> -->
      <el-button type="danger" icon="el-icon-delete" @click="deleteHandler" :disabled="selectRows.length<1" v-if="btnShow.delete">删除</el-button>
    </section>
    <!-- 数据表格 -->
    <section class="table">
      <el-table :data="tableData" max-height="550" border highlight-current-row @selection-change="checkHandler">
        <!--  @current-change="selectHandler" -->>
        <el-table-column  type="selection" width="40"></el-table-column>
        <el-table-column
          show-overflow-tooltip v-for="(x,i) in baseInfo" :key="i"
          :prop="x.key" :label="x.label" :fixed="x.fixed||false" :align="x.align||'center'"></el-table-column>
        <el-table-column label="操作" width="270" align="center">
          <template slot-scope="scope">
            <el-button size="mini" plain type="success" @click="navHandler(scope.row,'shebao_geren')">个人保险基本情况</el-button>
            <el-button size="mini" plain type="success" @click="navHandler(scope.row,'shebao_detail')">保险交纳情况</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagenation :pageData="pageData" @pageChange="pageChange"></Pagenation>
    </section>

    <!-- 模态框 查看模式 -->
    <DialogView
      ref="DialogView"
      :dialogTitle="dialogTitle"
      :formItems="formItems_"
      :formItems2="formItems2"
      dialogWidth="1000px" />

    <!-- 模态框 编辑模式 -->
    <DialogEdit
      ref="DialogEdit"
      :rules="rules"
      :dialogTitle="dialogTitle"
      :action="$api.url_upload_pu"
      :formItems="formItems"
      :formItems2="formItems2"
      @submitHandler="editSubmitHandler"
      @watchChange="watchChange"
      dialogWidth="1000px" />
      <!-- :isShowArea="true" -->

    <el-dialog
			title="导入提示"
			:close-on-click-modal="false"
			:visible.sync="isShowImportTip"
      :append-to-body="true"
			width="500px">
      <div v-html="importResult" style="text-align:left"></div>
    </el-dialog>
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import DialogEdit from '@/components/DialogEdit'
import DialogView from '@/components/DialogView'
// import AreaPicker from '@/components/AreaPicker_3'
import AreaPicker from '@/components/AreaPicker'
import Pagenation from '@/components/Pagenation'
import mixin_upload from '@/Mixins/mixin_upload'
import mixins from '@/Mixins/mixin_com'
import { powerMap } from '@/publicData/powerData'
export default {
  mixins: [mixins, mixin_upload],
  components: { AreaPicker, DialogView, DialogEdit, Pagenation },
  data() {
    return {
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
      sign: 'rlzy_guanlian_geren',
      dialogTitle: '关联个人信息',
      // fileName: 'qiyexinxi',

      baseInfo: [
        // { key: 'province', label: '省' },
        // { key: 'city', label: '市' },
        // { key: 'county', label: '县' },
        // { key: 'town', label: '镇' },
        // { key: 'village', label: '村' },
        // { key: 'areaName', label: '地区' },

        { key: 'u_nickName', label: '姓名' },
        { key: 'u_idCard', label: '身份证' },
        { key: 'f_age', label: '年龄' },
        { key: 'u_sex', label: '性别' },
        { key: 'u_workStatus', label: '人员状态' },
        { key: 'u_residenceType', label: '户口性质' },
        { key: 'u_residenceAddress', label: '户籍地址' },
        { key: 'u_liveAddress', label: '现住址' },
        { key: 'u_marriage', label: '婚姻状况' },
        { key: 'u_retireSodier', label: '退伍军人' },
        { key: 'u_political', label: '政治面貌' },
        { key: 'u_education', label: '学历' },
        { key: 'u_major', label: '专业' },
        { key: 'u_bankNumber', label: '银行卡号' },
        { key: 'u_phone', label: '联系方式' },
        { key: 'u_remarks', label: '备注' },
      ],
      // watchChangeKey: ['buyType'],
      // defaultKeyValue: {
      //   buyType: 1
      // },
      userList: [],
      rules: {
        coUserId: [{ required: true, message: '必填', trigger: 'change' }],
      },

      isShowDetail: false,
    }
  },
  computed: {
    // importAction() {
    //   return this.$api.baseUrl + '/user/sync/company/' + this.userInfo.areaId
    // },
    formItems() {
      console.log(this.isCreate)
      if (this.isCreate) {
        return [
          { type: 'select_s', key: 'coUserId', label: '身份证', options: this.userList, remoteMethod: this.getUesrData, isWatch: true },
          { type: 'text', key: 'u_nickName', label: '对象姓名', disabled: true },
        ]
      } else {
        return [
          { type: 'text', key: 'u_nickName', label: '姓名', disabled: true },
          { type: 'text', key: 'u_idCard', label: '身份证', disabled: true },
          { type: 'text', key: 'f_age', label: '年龄' },
          { type: 'select_s', key: 'u_sex', label: '性别', options: ['男','女'] },
          { type: 'select_s', key: 'u_workStatus', label: '人员状态', options: ['在职','离职','求职'] },
          { type: 'text', key: 'u_residenceType', label: '户口性质' },
          { type: 'text', key: 'u_residenceAddress', label: '户籍地址' },
          { type: 'text', key: 'u_liveAddress', label: '现住址' },
          { type: 'select_s', key: 'u_marriage', label: '婚姻状况', options: ['已婚','未婚'] },
          { type: 'text', key: 'u_retireSodier', label: '退伍军人' },
          { type: 'select_s', key: 'u_political', label: '政治面貌', options: ['群众', '共青团员', '党员'] },
          { type: 'select_s', key: 'u_education', label: '学历', options: ['高中', '中专', '大专', '本科', '硕士', '博士', '其它'] },
          { type: 'text', key: 'u_major', label: '专业' },
          { type: 'text', key: 'u_bankNumber', label: '银行卡号' },
          { type: 'text', key: 'u_phone', label: '联系方式' },
          { type: 'text', key: 'u_remarks', label: '备注' },
        ]
      }
    },
    formItems_() {
      return []
    },
    formItems2() {
      return null
    }
  },
  methods: {
    navHandler(row, route) {
      this.$router.push(route + '?id=' + row.u_idCard)
      this.clickMenu(route)
    },
    // ——————————————————————————————————————————————————————————————
    searchHandler() {
      let rD = this.beforeSearchAndExportHandler(this.filterForm)
      rD.pageNumber = this.pageData.currentPage
      // console.log(rD)
      this.getData(rD)
    },
    // modifyHandlerBefore() {
    //   let {
    //     coUser
    //   } = this.selectData
    //   console.log(coUser.u_idCard)
    //   this.userList = [
    //     {
    //       label: coUser.u_idCard,
    //       value: coUser.id,
    //     }
    //   ]
    // },
    watchChange(data) {
      // console.log(`%caaaa:`, 'color: #f00;', data)
      switch (data.key) {
        // case 'buyType':
        //   if (data.val === 1) {
        //     this.formItems.splice(9, 1)
        //   } else if (data.val === 2) {
        //     this.formItems.splice(9, 1, { type: 'text', key: 'cash', label: '垫付金额' })
        //   }
        //   break;
        case 'coUserId':
          let item = this.userList.find(x => x.value === data.val)
          console.log(item)
          this.$refs.DialogEdit.eData.u_nickName = item.nickName
          break;
      }
    },
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
    editSubmitHandler(result) {
      console.log(`%cresult:`, 'color: #00f;', result)
      // let { id, province, city, county, town, village } = result
      let { id } = result
      // let rData = { province, city, county, town, village }
      let rData = {}
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
      if (this.isCreate) {
        rData = {
          // province, city, county, town, village,
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
          coUserId,
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        }
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        rData.userId = this.userInfo.id
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        console.log(rData)
        
        this.$api.util_create(this.sign, rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('创建成功！')
            this.$refs.DialogEdit.isShowDialog = false
            this.$refs.DialogEdit.clearHandler()
            this.searchHandler()
          } else { this._status(res.data) }
        })
      }

      else {
        // const mapList_must = ['province', 'city', 'county', 'town', 'village']
        // mapList_must.forEach(x => {
        //   rData[x] = result[x]
        // })
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 区别处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        const mapList = [
          'f_age',
          'u_sex',
          'u_workStatus',
          'u_residenceType',
          'u_residenceAddress',
          'u_liveAddress',
          'u_marriage',
          'u_retireSodier',
          'u_political',
          'u_education',
          'u_major',
          'u_bankNumber',
          'u_phone',
          'u_remarks',
        ]
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 区别处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        mapList.forEach(x => {
          if (this.selectData[x] !== result[x]) {
            rData[x] = result[x]
          }
        })
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
        rData.id = this.selectData.coUserId // 绑定修改的数据id
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
        console.log(rData)

        this.$api._user_modify(rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('修改成功！')
            this.$refs.DialogEdit.isShowDialog = false
            this.$refs.DialogEdit.clearHandler()
            this.searchHandler()
          } else { this._status(res.data) }
        })
      }
    },
    getData(rD = {}) {
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
      rD.userId = this.userInfo.id
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
      this.$api.util_search(this.sign, rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c_R:`, 'color: #f00;', _R)
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
          // this.tableData = _R
          this.tableData = _R.map(x => {
            let obj = JSON.parse(JSON.stringify((x.coUser)))
            obj.id = x.id
            obj.userId = x.userId
            obj.coUserId = x.coUserId
            return obj
          })
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
          this.pageData.total = res.data.size
        } else { this._status(res.data) }
      })
    },
    getUesrData(val) {
      console.log(val, this.areaIds_x)
      let rD = {
        // areaId: this.areaIds_x[this.areaIds_x.length - 1],
        u_idCard: val,
        personal: true,
      }
      // console.log(rD)
      this.$api.getUserList(rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          this.userList = _R.map(x => {
            return {
              label: x.u_idCard,
              nickName: x.u_nickName || x.name,
              value: x.id,
            }
          })

          // 如果对话框里有切换的项目，修改前要先切换到对应的项目
          if(this.watchChangeKey) {
            let eData = this.$refs.DialogEdit.eData
            console.log(`%ceData:`, 'color: #f00;', eData)
            this.watchChangeKey.forEach(x => {
              this.watchChange({ key: x, val: eData[x] })
            })
          }
          console.log(`%c用户数据:`, 'color: #00f;', this.userList)
        } else { this._status(res.data) }
      })
    },
  },
  created() {
    const powerList = this.userInfo.privilegesList
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓ 特殊处理 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
    const powerStr = powerMap[this.sign]
    // const powerStr = powerMap[this.catalog]
    // console.log(powerStr)
// ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ 特殊处理 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
    const mapList = ['search','create','modify','delete','import','export']
    if (this.userInfo.admin) {
      mapList.forEach(x => {
        this.btnShow[x] = true
      })
    } else {
      mapList.forEach(x => {
        if (x && powerList.includes(powerStr + '-' + x)) {
          this.btnShow[x] = true
        }
      })
    }
    if (powerList.includes(powerStr + '-create')) {
      this.btnShow.modify = true
    }
    this.filterHandler()
  },
}
</script>

<style lang='scss' scoped>
.section-filter{display: flex;overflow-x: auto;}
.section-filter>div{flex-shrink: 0;}
.filter-col{display: flex;flex-direction: column;}
.filter-area{display: flex;}
.filter-area-label{margin:5px 10px 0 50px;font-size: 14px;}
.filter-btn{margin-left: 20px;}

.section-btns{padding-left: 15px;margin-right: 10px;display: flex;}
/deep/.section-btns .el-upload-list{display: none;}





.file-item{height: 40px;line-height: 40px;display: flex;}
.file-name{
  display: inline-block;min-width: 120px;max-width: 200px;padding: 0 10px;
  overflow: hidden;white-space: nowrap;text-overflow: ellipsis;
}
</style>